/**
 * GPS Lost Legend Content
 * Displays the GPS Lost heatmap legend
 */

import React from 'react';
import { cn } from '@ais-ui/utils';
import { LegendConfig } from '@ais-ui/websockets';
import { ItemInterval, useGridColumns } from '../shared';

interface GPSLostLegendContentProps {
  legend: LegendConfig<'interval'>;
}

export const GPSLostLegendContent: React.FC<GPSLostLegendContentProps> = ({
  legend,
}) => {
  const gridColumnsClass = useGridColumns({
    itemCount: legend.items.length,
    maxItemsPerColumn: 10,
    maxColumns: 2,
  });

  return (
    <div className={cn('grid gap-y-1.5 gap-x-4', gridColumnsClass)}>
      {legend.items.map((item, index) => (
        <ItemInterval key={index} legend={legend} item={item} />
      ))}
    </div>
  );
};
